import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { Label } from "@/components/Product/Label/label";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const ProductLabelContainer = () => {
    const { t } = useGranite();

    const { discountPercentage } = useECommerceProduct();

    return (
        <Label
            position={"left"}
            type={"label"}
        >
            <Label.Entry>{t("promotionLabel.promo")}</Label.Entry>
            <Label.Entry>{discountPercentage}%</Label.Entry>
        </Label>
    );
};

export { ProductLabelContainer };
